import { render } from "./CompleteProfile.vue?vue&type=template&id=5e2807e3&scoped=true"
import script from "./CompleteProfile.vue?vue&type=script&lang=js"
export * from "./CompleteProfile.vue?vue&type=script&lang=js"

import "./CompleteProfile.vue?vue&type=style&index=0&id=5e2807e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2807e3"]])

export default __exports__